import React, { ReactNode, FC, useContext, useCallback, useMemo } from "react";

import classnames from "classnames";

import { AccordionContext } from "./Accordion";
import { ItemContext } from "./AccordionItem";
import {
  StyledAccordionItemHead,
  StyledAccordionItemHeadText,
  StyledAccordionItemHeadIcon,
} from "./Styles";
import CollapseExpandSingleIcon from "../Icons/collection/CollapseExpandSingle";

export interface IAccordionItemHead {
  /** Children type of node or string */
  children: ReactNode | string;
  /** ClassName */
  className?: string;
}

export const AccordionItemHead: FC<IAccordionItemHead> = ({
  children,
  className,
}) => {
  const accordionContext = useContext(AccordionContext);
  const itemContext = useContext(ItemContext);

  const { toggleExpanded, disableToggleIcon, customToggleIcon } =
    useMemo(() => {
      return {
        toggleExpanded: accordionContext
          ? accordionContext.toggleExpanded
          : null,
        disableToggleIcon: accordionContext
          ? accordionContext.disableToggleIcon
          : false,
        customToggleIcon: accordionContext
          ? accordionContext.customToggleIcon
          : null,
      };
    }, [accordionContext]);

  const id = useMemo(() => (itemContext ? itemContext.id : ""), [itemContext]);

  const onClickCallback = useCallback(() => {
    if (toggleExpanded) {
      toggleExpanded(id);
    }
  }, [id, toggleExpanded]);

  const toggleIcon = useMemo(
    () =>
      customToggleIcon ? (
        customToggleIcon
      ) : (
        <CollapseExpandSingleIcon style={{ transform: "rotate(180deg)" }} />
      ),
    [customToggleIcon]
  );

  return (
    <StyledAccordionItemHead
      onClick={onClickCallback}
      className={classnames("accordionItemHead", className)}
    >
      <StyledAccordionItemHeadText className="accordionItemHead__text">
        {children}
      </StyledAccordionItemHeadText>
      <StyledAccordionItemHeadIcon className="accordionItemHead__icon">
        {!disableToggleIcon ? toggleIcon : null}
      </StyledAccordionItemHeadIcon>
    </StyledAccordionItemHead>
  );
};

AccordionItemHead.displayName = "AccordionItemHead";
